import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 首次登錄或既有序號重測。payload 的 serialNumber 保持原樣。 */
export async function createInspectionReport(payload) {
  const { data: raw } = await request.post(
    '/ims/inspection-reports',
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
